export const FOUNDER_PROFILE = {
  name: 'Mustafa Can Arslan',
  role: 'Founder & Developer',
  image: '/images/founder/mustafa-can-arslan.webp',
  imageWidth: 894,
  imageHeight: 894,
  linkedIn: 'https://www.linkedin.com/in/mustafa-can-arslan-7a7b6a423/',
  instagram: 'https://www.instagram.com/pysrec',
  aeroCore: 'https://aerocorescripts.com',
};

export const FOUNDER_INTRODUCTION = {
  eyebrow: "Who you'll be working with",
  greeting: "Hi, I'm Mustafa.",
  paragraphs: [
    'I build websites and systems for small businesses and online communities.',
    'Before this I spent years building tools for gaming communities — booking flows, payment integrations, admin panels. The same things a clinic or a showroom needs, just a different audience.',
    "You'll work with me directly. No account managers, no handoffs.",
  ],
};
